import React, { createContext, useContext, useState, useEffect } from 'react';
// import { generateClient } from 'aws-amplify/api';
// import { listSegments } from '../graphql/queries';
import segmentService from '../api/tenantApi';
import { useSelector } from 'react-redux';
import getTenantIdFromURL from '../utils/getTenantIdFromURL';
// import { listCompaniesBySegmentID, listCompaniesForSegments } from '../utils/Helper';
import companyAPi from '../api/companyApi';
import { toast } from 'react-toastify';
const SegmentContext = createContext();
// const API = generateClient();

export const useSegment = () => {
  const context = useContext(SegmentContext);
  if (!context) {
    throw new Error('useSegment must be used within a SegmentProvider');
  }
  return context;
};

export const SegmentProvider = ({ children }) => {
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [segments, setSegments] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [segmentsLoading, setSegmentsLoading] = useState(true);
  const [companiesLoading, setCompaniesLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Get tenant ID based on user role from Redux
  const isAdmin = useSelector(state => state.userInfo.isAdmin);
  const currentTenant = useSelector(state => state.userInfo.tenantId);
  const URLTenant = getTenantIdFromURL();
  const tenantId = isAdmin ? URLTenant : currentTenant;

  const fetchSegments = async (tenantId, nextToken = null) => {
    if (!tenantId) {
      console.log('No tenant ID provided');
      return;
    }
    
    console.time('timefetchSegments');
    try {
      setSegmentsLoading(true);
      console.log('Fetching segments for tenant:', tenantId);
      
      let allSegments = [];
      let currentNextToken = nextToken;
      
      console.time('timefetchSegmentsLoop');
      do {
        const response = await segmentService.getSegmentsByTenantId(tenantId, 20, currentNextToken);
        currentNextToken= response.data.nextToken;   
    
        const fetchedSegments = response.data;
        
        // For each segment, fetch its companies
        console.time('timefetchCompaniesForSegments');
        const segmentsWithCompanies = await Promise.all(
          fetchedSegments.map(async (segment) => {
            let allSegmentCompanies = [];
            
    
              const companiesResponse = await companyAPi.getCompaniesBySegmentId(tenantId,segment.id);
              
              // Fix: Ensure fetchedCompanies is always an array
              const fetchedCompanies = Array.isArray(companiesResponse.data?.companies)
                ? companiesResponse.data?.companies
                : (companiesResponse.data?.items || []);
              allSegmentCompanies = [...allSegmentCompanies, ...fetchedCompanies]
       

            return {
              ...segment,
              companies: {
                items: allSegmentCompanies,
                nextToken: null 
              }
            };
          })
        );
        console.timeEnd('timefetchCompaniesForSegments');
        allSegments = [...allSegments, ...segmentsWithCompanies];
        currentNextToken = response.data.nextToken;
      } while (currentNextToken);
      console.timeEnd('timefetchSegmentsLoop');

      console.log('Fetched segments with companies:', allSegments);
      setSegments(allSegments || []);
      console.log("allSegments",allSegments)
      setError(null);
    } catch (err) {
      console.error('Error fetching segments:', err);
      setError('Failed to fetch segments');
      setSegments([]);
    } finally {
      setSegmentsLoading(false);
      console.timeEnd('timefetchSegments');
    }
  };

  const fetchCompanies = async (tenantId) => {
    if (!tenantId) return;
    
    try {
      setCompaniesLoading(true);
      
      const response = await companyAPi.searchCompanies(tenantId);

      console.log('Total unique companies fetched:', response.data?.companies?.length);
      setCompanies(response.data?.companies);
      setError(null);
    } catch (err) {
      console.error('Error fetching companies:', err);
      setError('Failed to fetch companies');
      setCompanies([]);
    } finally {
      setCompaniesLoading(false);
    }
  };

  const updateSegment = (segment) => {
    console.log("Updating segment in context:", segment?.name);
    console.log("Previous segment:", selectedSegment?.name);
    setSelectedSegment(segment);
  };

  const refreshData = async () => {
    console.log("Refreshing segment data");
    if (tenantId) {
      await Promise.all([
        fetchSegments(tenantId),
        fetchCompanies(tenantId)
      ]).catch(err => {
        console.error('Error refreshing data:', err);
        setError('Failed to refresh data');
      });
    }
  };

  // Fetch segments and companies when tenant ID changes
  useEffect(() => {
    if (tenantId) {
      Promise.all([
        fetchSegments(tenantId),
        fetchCompanies(tenantId)
      ]).catch(err => {
        console.error('Error fetching data:', err);
        setError('Failed to fetch data');
      });
    } else {
      setSegmentsLoading(false);
      setCompaniesLoading(false);
      setSegments([]);
      setCompanies([]);
    }
  }, [tenantId]);

  return (
    <SegmentContext.Provider 
      value={{ 
        selectedSegment, 
        setSelectedSegment: updateSegment,
        segments,
        companies,
        segmentsLoading,
        companiesLoading,
        error,
        fetchSegments,
        fetchCompanies,
        refreshData
      }}
    >
      {children}
    </SegmentContext.Provider>
  );
}; 